export default function newarrivals({ img }) {
  return (
    <>
      <div id="newarrivals">
        <p>NEW ARRIVALS!</p>
        {/* <div id="pdata">
          <div id="nbox">
            <img className="productimage" src={img} alt="na" />
            <p>Mamaearth Rice Face Scrub For Glowing With Rice Water</p>
            <p>⭐⭐⭐⭐⭐(1)</p>
            <div>
              <h3 className="originalprice">₹350</h3>
              <h3 className="offerprice">₹304</h3>
              <h3 className="discount">13%</h3>
            </div>
            <button className="addtocart">Add To Cart</button>
            <button className="witlist">🤍</button>
          </div>
        </div> */}
      </div>
    </>
  );
}
